import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.useNonExistentCompanyError', {
    companyNotFound: 'Company not found',
});
